/** 静态目录首页与站内规范 URL 使用同一路由，包括直接打开 index.html。 */
export function normalizeRoutePath(pathname: string): string {
  return pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
}
